<template>
    <div class="container">
        <div class="handle-box-search">

            <el-row class="head-search" style="margin-bottom: 20px">
                <el-col :span="6">
                   活动充值总金额:{{prizes.total_amount}}

                </el-col>

                <el-col :span="6">
                  活动参与人数:{{prizes.person}}

                </el-col>
                <el-col :span="6">
                    礼包一数量:{{prizes.prize_one.num}}

                </el-col>
                <el-col :span="6">
                    礼包二数量:{{prizes.prize_two.num}}

                </el-col>
            </el-row>


            <el-row class="head-search">
                <el-col :span="8">
                    <span class="title" style="min-width: 100px">用户手机号:</span>
                    <!-- 搜索客户姓名-->
                    <el-input
                            v-model="search_data.consumer_phone"
                            placeholder="用户手机号 "
                            class="handle-input mr10"
                            maxlength="11"
                            @keyup.enter.native="searchactiveRecords"
                    ></el-input>
                </el-col>

                <el-col :span="8">
                    <span class="title" style="min-width: 100px">收件人手机号:</span>
                    <!-- 搜索客户姓名-->
                    <el-input
                            v-model="search_data.phone"
                            placeholder="请输入收件人手机号 "
                            class="handle-input mr10"
                            maxlength="11"
                            @keyup.enter.native="searchactiveRecords"
                    ></el-input>
                </el-col>

                <el-col :span="8">
                    <span class="title" style="min-width: 100px">礼包:</span>
                    <!-- 搜索手机号码 -->
                    <el-select v-model="search_data.prize_code" placeholder="请选择" clearable>
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>



            <el-button type="primary" icon="el-icon-search" @click="searchactiveRecords">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
        </div>
        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column prop="consumer_phone" label="用户手机号" min-width="150"> </el-table-column>

            <el-table-column prop="created_at" label="参与时间" min-width="150"> </el-table-column>

            <el-table-column prop="money" label="充值金额" min-width="150"> </el-table-column>
            <el-table-column prop="prize_name" label="选择礼包" min-width="150"> </el-table-column>

            <el-table-column prop="name" label="收件人姓名" min-width="150"> </el-table-column>

            <el-table-column prop="phone" label="收件人手机号" min-width="150"> </el-table-column>

            <el-table-column prop="address" label="收件人地址" min-width="150"> </el-table-column>
            <el-table-column prop="status" label="发货状态" min-width="150">
                <template slot-scope="scope">
                        {{ scope.row.status == 0 ? '未发货' : '已发货' }}
                </template>
            </el-table-column>

            <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                    <el-button @click="config(scope.row.prize_record_code,scope.row.prize_name)">发货配置</el-button>
                </template>
            </el-table-column>
        </el-table>
        <configure :isShow="add_isShow" :prize="prizeC" :prize_record_code="prize_record_code" @onSubmit="activeRecords"></configure>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>
    </div>
</template>

<script>
    var _this;
    import configure from './configure.vue';
    export default {
        components: {
            configure,
        },
        data() {
            return {
                add_isShow: false,
                // 存放表格数据
                tableData: [],


                prizes:{},

                prize_record_code:'',
                prizeC:'',

                options:[],

                //翻页数据
                search_data: {
                    page: 1,
                    limit: 10,
                    consumer_phone: '',
                    phone: '',
                    prize_code: ''
                },

                result_data: [],
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    }
                }
            };
        },
        created() {
            _this = this;
            _this.activeRecords();

            //礼品发放统计
            _this
                .$post("/activeprize/prizes")
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中

                    _this.prizes = res.data;

                    _this.options = [{
                        label:res.data.prize_one.name,
                        value:res.data.prize_one.prize_code,
                    },{
                        label:res.data.prize_two.name,
                        value:res.data.prize_two.prize_code,
                    }];

                })
                .catch((err) => {});


            // // 接收子组件传来的事件并初始化列表
            // bus.$on('onSubmit', (msg) => {
            //     _this.consumerScancodeLists();
            // });
        },

        methods: {

            config(code,name){
                _this.prize_record_code = code;
                _this.prizeC = name;
                _this.add_isShow = !_this.add_isShow;
            },

            searchactiveRecords() {
                _this.search_data.page = 1;
                _this.activeRecords();
            },

            activeRecords() {
                _this
                    .$post('/activeprize/activeRecords', _this.search_data, _this.search_rules)
                    .then((res) => {
                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data.result;
                        _this.result_data = res;
                    })
                    .catch((err) => {});
            },
            // 翻页组件的回调
            pages_function(search_data) {
                console.log(_this.search_data);

                //赋值
                _this.search_data = search_data;
                //初始化列表
                _this.activeRecords();
            },

            // 刷新按钮
            refresh() {
                this.$router.go(0);
            }
        }
    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 200px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

    .el-table__row {
        height: 100px;
    }

    .el-dropdown {
        vertical-align: top;
    }

    .el-dropdown + .el-dropdown {
        margin-left: 15px;
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }
</style>
